export default "__VITE_ASSET__by4HIrQZ__"